/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
import _ from 'lodash';
import React, { Component } from 'react';
import { Modal, Card, FormLayout, TextField } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class RenameTemplateModal extends Component<ComposedProps, State> {
  state = {
    inputTemplateName: ''
  };

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({ inputTemplateName: nextProps.templateName });
  }

  render() {
    const { open, onClose, loading, i18n } = this.props;
    const { inputTemplateName = '' } = this.state;

    return (
      <div className="select-template-modal">
        <Modal
          open={open}
          onClose={onClose}
          title={i18n.translate('AdminHTML.ShopifyIntegration.RenameModal.title')}
          primaryAction={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.save'),
              onAction: () => {
                this.props.onConfirm(inputTemplateName);
              },
              loading: loading,
              disabled: _.isEmpty(inputTemplateName) || inputTemplateName.length > 50
            }
          ]}
          secondaryActions={[
            {
              content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.cancel'),
              onAction: this.props.onClose
            }
          ]}>
          {/* Content */}
          <div className="manage-template-modal-content">
            <Card>
              <Card.Section>
                <FormLayout>
                  <TextField
                    value={inputTemplateName}
                    onChange={this.handleChangeTemplateName}
                    placeholder={i18n.translate(
                      'AdminHTML.ShopifyIntegration.RenameModal.placeholder'
                    )}
                  />
                </FormLayout>
              </Card.Section>
            </Card>
          </div>
        </Modal>
      </div>
    );
  }

  handleChangeTemplateName = templateName => {
    this.setState({ inputTemplateName: templateName });
    this.props.onChange(templateName);
  };
}

export default withI18n()(RenameTemplateModal);
